var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { GeofenceType } from '@tenderd/schema';
import { useAuth, useMixpanel, useService } from '@tenderd/track-web-utils';
import { Form, message } from 'antd';
import { useEffect, useState } from 'react';
import { useGroupService } from '../../../../providers/GroupServiceProvider';
import { GroupGeofenceAction, useGroupGeofencePageContext, } from '../../GroupGeofencePage.context';
var usePostGeofence = function () {
    var service = useService();
    var groupService = useGroupService();
    var _a = __read(useState(false), 2), archiveConfirm = _a[0], setArchiveConfirm = _a[1];
    var _b = __read(Form.useForm(), 1), form = _b[0];
    var typeValue = Form.useWatch('type', form);
    var allowedEquipmentValue = Form.useWatch('allowedEquipmentTypes', form);
    var account = useAuth().account;
    var mixpanel = useMixpanel();
    var _c = __read(useState(false), 2), loading = _c[0], setLoading = _c[1];
    var context = useGroupGeofencePageContext();
    var _d = __read(useState([]), 2), equipmentTypes = _d[0], setEquipmentTypes = _d[1];
    useEffect(function () {
        service.server
            .getEquipmentTypesOfAccount(account.id)
            .then(function (res) {
            setEquipmentTypes(res);
        })
            .catch(function (err) {
            message.error(err.message);
        });
    }, []);
    var EquipmentTypes = __spreadArray([], __read(new Set(equipmentTypes)), false);
    var defaultValues = {
        name: '',
        type: GeofenceType.Standard,
        allowedEquipmentTypes: [],
    };
    useEffect(function () {
        if (allowedEquipmentValue && allowedEquipmentValue.includes('all')) {
            form.setFieldValue('allowedEquipmentTypes', EquipmentTypes);
        }
    }, [allowedEquipmentValue]);
    useEffect(function () {
        if (context.geofenceAction === GroupGeofenceAction.AddGeofence) {
            form.setFieldsValue(defaultValues);
        }
        else {
            form.setFieldsValue(context.selectedGeofence);
        }
    }, [
        context.postGeofenceModal,
        context.geofenceAction,
        context.selectedGeofence,
    ]);
    var onSubmit = function (values) {
        try {
            setLoading(true);
            var payload_1 = {
                allowedEquipmentTypes: values.allowedEquipmentTypes,
                account_ref: {
                    id: account.id,
                    label: account.doc.name,
                },
                name: values.name,
                type: values.type,
                group_ref: {
                    id: groupService.group.id,
                    label: groupService.group.doc.name,
                },
                geofence: [],
            };
            if (context.geofenceAction === GroupGeofenceAction.UpdateGeofence) {
                payload_1 = __assign(__assign({}, payload_1), { geofence: context.selectedGeofence.geofence, locationMarkers: context.selectedGeofence.locationMarkers });
                service.server
                    .updateGroupGeofence(context.selectedGeofence._id, payload_1)
                    .then(function () {
                    message.success('Geofence updated successfully');
                    mixpanel.track('Updated geofence', { extension: 'track' });
                    context.setPostGeofenceModal(false);
                    context.updateGeofenceData('update', __assign(__assign({}, context.selectedGeofence), payload_1));
                })
                    .catch(function (err) {
                    message.error(err.message);
                })
                    .finally(function () {
                    setLoading(false);
                });
                return;
            }
            service.server
                .addGroupGeofence(payload_1)
                .then(function (res) {
                message.success('Geofence created successfully');
                mixpanel.track('Created geofence', { extension: 'track' });
                context.setPostGeofenceModal(false);
                context.updateGeofenceData('add', res);
            })
                .catch(function (err) {
                message.error(err.message);
            })
                .finally(function () {
                setLoading(false);
            });
        }
        catch (error) {
            message.error(error);
        }
    };
    return {
        defaultValues: defaultValues,
        typeValue: typeValue,
        form: form,
        archiveConfirm: archiveConfirm,
        loading: loading,
        EquipmentTypes: EquipmentTypes,
        setArchiveConfirm: setArchiveConfirm,
        onSubmit: onSubmit,
    };
};
export default usePostGeofence;
